import { render, staticRenderFns } from "./AddonsLocaleEditor.vue?vue&type=template&id=2174b964&scoped=true"
import script from "./AddonsLocaleEditor.vue?vue&type=script&lang=ts"
export * from "./AddonsLocaleEditor.vue?vue&type=script&lang=ts"
import style0 from "./AddonsLocaleEditor.vue?vue&type=style&index=0&id=2174b964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174b964",
  null
  
)

export default component.exports